export enum NyalaCustodyProvider {
    HADC = 0,
    TANGANY = 1,
    IRIS = 3,
}
